import React from 'react';
import styles from './MultiQuestionScale.module.scss';
import { FeedbackFormElementMultiScale } from '../../../../../../../../types';
import OptionsList from '../options-list/OptionsList';
import { useFeedbackForm } from '../../useFeedbackFormEdit';
import { TextInputValue } from '../../../../../../../../components/text-input/TextInput';

type Props = {
  element: FeedbackFormElementMultiScale;
  index: number;
  showError: boolean;
  isAssessable?: boolean;
};

const uniqueId = () => `id-${Date.now().toString(16)}`;

function MultiQuestionScale(props: Props) {
  const { element, index: parentIndex, showError, isAssessable } = props;

  const { changeElementsValue, addOption, removeOption, onChangeChecks } = useFeedbackForm();

  const handleAddStatementOption = () => {
    addOption(parentIndex, {
      id: uniqueId(),
      value: '',
    }, true);
  };

  const handleRemoveStatementOption = (index: number) => {
    removeOption(parentIndex, index, true);
  };

  const handleChangeStatementOption = (index: number, value: TextInputValue) => {
    changeElementsValue(value, `${parentIndex}.statements.${index}.value`);
  };

  const handleChangeAnswerOption = (index: number, value: string) => {
    changeElementsValue(value, `${parentIndex}.statements.${index}.assessment`);
  };

  const handleAddOptionsOption = () => {
    addOption(parentIndex, '');
  };

  const handleRemoveOptionsOption = (index: number) => {
    removeOption(parentIndex, index);
  };

  const handleChangeOptionsOption = (index: number, value: TextInputValue) => {
    changeElementsValue(value, `${parentIndex}.options.${index}`);
  };

  return (
    <div>
      <div className={styles.label}>Statement</div>
      <div className={styles.statements}>
        <OptionsList
          options={element?.statements ?? []}
          showError={showError}
          onRemove={handleRemoveStatementOption}
          onChange={handleChangeStatementOption}
          onAdd={handleAddStatementOption}
          parentIndex={parentIndex}
          isAssessable={isAssessable}
          isMultiScale
          onChangeChecks={onChangeChecks}
          answerOptions={element?.options ?? []}
          onChangeAnswerOption={handleChangeAnswerOption}
        />
      </div>
      <div className={styles.divider} />
      <div className={styles.answers}>
        <div className={styles.label}>Answers</div>
        <OptionsList
          options={element?.options ?? []}
          showError={showError}
          onRemove={handleRemoveOptionsOption}
          onChange={handleChangeOptionsOption}
          onAdd={handleAddOptionsOption}
          parentIndex={parentIndex}
        />
      </div>
    </div>
  );
}

export default MultiQuestionScale;
